//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { SearchBar } from '@giscube/geoportal';
export default {
  name: 'HomePanel',
  components: {
    SearchBar: SearchBar
  },
  data: function data() {
    return {};
  }
};